/* eslint-disable no-else-return */
import { GLOBAL_DATE_FORMAT, GLOBAL_DATE_TIME_FORMAT, PAYLOAD_DATE_TIME_FORMAT } from 'constant';
import moment from 'moment';
import { instanceOf } from 'prop-types';

export const convertToUTC = (date) => {
    const utc = moment(new Date(date)).utc().format('YYYY-MM-DDT hh:mm A');
    console.log(utc, '- now in UTC');
    return utc;
};

export const convertToLocal = (date) => {
    if (date) {
        const local = moment.utc(date).local().format('YYYY-MM-DDT hh:mm A');
        console.log(local, '- UTC now to local');
        return local;
    } else return '';
};

export const convertToUTC24 = (date, format) => {
    if (date) {
        const utc = moment(new Date(date))
            .utc()
            .format(format || 'YYYY-MM-DD hh:mm');
        return utc;
    } else return '';
};

export const convertToUTC24Safari = (date, format) => {
    if (!date) return '';

    const parsed = moment(date, ['YYYY-MM-DD HH:mm', 'YYYY-MM-DDTHH:mm', 'YYYY-MM-DDTHH:mm:ss', 'MM-DD-YYYY HH:mm'], true);

    if (!parsed.isValid()) {
        console.error('Invalid date format:', date);
        return '';
    }

    const utc = parsed.utc().format(format || 'YYYY-MM-DD hh:mm');
    return utc;
};

export const convertToUTC24NewSafari = (date, format) => {
    if (!date) return '';

    const parsed = moment(date.replace(/-/g, '/'));

    if (!parsed.isValid()) {
        console.error('Invalid date format:', date);
        return '';
    }

    const utc = parsed.utc().format(format || 'YYYY-MM-DD hh:mm');
    return utc;
};

export const convertToLocal24 = (date, format) => {
    if (date) {
        console.log('convertToLocal24', date, format);

        const local = moment
            .utc(date)
            .local()
            .format(format || 'YYYY-MM-DD hh:mm');

        console.log('convertToLocal24 local', local);
        return local;
    } else return '';
};

export const convertToLocal24Safari = (date, format) => {
    if (!date) return '';
    console.log('convertToLocal24Safari', date, format);
    // Specify input format: MM-DD-YYYY HH:mm
    const local = moment
        .utc(date, 'MM-DD-YYYY HH:mm', true) // strict parsing
        .local()
        .format(format || 'YYYY-MM-DD HH:mm'); // 24-hour
    console.log('convertToLocal24Safari local', local);
    return local;
};

export const convertToStartDayUTC = (date, format) => {
    if (date) {
        const utc = moment(new Date(date))
            .startOf('day')
            .utc()
            .format(format || PAYLOAD_DATE_TIME_FORMAT);
        return utc;
    } else return '';
};

export const convertToEndDayUTC = (date, format) => {
    if (date) {
        const utc = moment(new Date(date))
            .endOf('day')
            .utc()
            .format(format || PAYLOAD_DATE_TIME_FORMAT);
        return utc;
    } else return '';
};

export const convertZToLocalOnly = (date) => {
    if (date) {
        const input = new Date(date);

        const year = input.getUTCFullYear();
        const month = String(input.getUTCMonth() + 1).padStart(2, '0');
        const day = String(input.getUTCDate()).padStart(2, '0');
        const hours = String(input.getUTCHours()).padStart(2, '0');
        const minutes = String(input.getUTCMinutes()).padStart(2, '0');
        const formatted = `${year}-${month}-${day} ${hours}:${minutes}`;
        const dte = moment(formatted).local();

        return dte;
    } else return '';
};

export const convertToStartDay = (date, format) => {
    if (date) {
        const dte = moment(new Date(date))
            .set({ hour: 0, minute: 0, second: 0 })
            .format(format || 'YYYY-MM-DD HH:mm');

        return dte;
    } else return '';
};

export const convertToEndDay = (date, format) => {
    if (date) {
        const dte = moment(new Date(date))
            .set({ hour: 23, minute: 59, second: 59 })
            .format(format || 'YYYY-MM-DD HH:mm');
        return dte;
    } else return '';
};

export const convertToFormat = (date, format) => {
    let ds = '';
    if (!date) return ds;
    if (typeof date === 'string') {
        ds = moment.utc(date).format(format || 'YYYY-MM-DD hh:mm');
    } else {
        ds = moment.utc(new Date(date)).format(format || 'YYYY-MM-DD hh:mm');
    }
    return ds;
};

export const convertMinToHrs = (duration, num = false) => {
    if (typeof duration !== 'number' || duration < 0) {
        return 'Invalid duration';
    }

    // if num is true return the number of hours
    if (num) {
        const hours = duration / 60;
        return hours;
    }

    if (duration >= 60) {
        const hours = Math.floor(duration / 60);
        const minutes = duration % 60;
        if (hours === 1 && minutes === 0) {
            return '1 Hr';
        } else if (hours === 1 && minutes > 0) {
            return `1 Hr ${minutes} Min`;
        } else if (hours > 1 && minutes === 0) {
            return `${hours} Hr`;
        } else {
            return `${hours} Hr ${minutes} Min`;
        }
    } else {
        return `${duration} Min`;
    }
};

export const getTimeDeltaBasedOnType = (type) => {
    // eslint-disable-next-line default-case
    switch (type) {
        case 'today': {
            const now = new Date();

            return [now, now];
        }
        case 'week': {
            const now = new Date();
            const startOfWeek = new Date(now.setDate(now.getDate() - now.getDay()));
            const endOfWeek = new Date(now.setDate(now.getDate() - now.getDay() + 6));

            return [startOfWeek, endOfWeek];
        }
        case 'month': {
            const now = new Date();

            const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
            const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            return [startOfMonth, endOfMonth];
        }
    }

    return [];
};

export const utcToLocal = (date, format = GLOBAL_DATE_FORMAT) => {
    console.log('utcToLocal::', date);

    if (!date) return '';
    // if (instanceOf(date, 'Date')) date = date.getTime();
    const local = moment.utc(date).local().format(format);
    console.log('utcToLocal local::', local);
    return local;
};

export const utcToLocalSafari = (date, format = GLOBAL_DATE_FORMAT) => {
    console.log('utcToLocal::', date);

    if (!date) return '';

    // Tell moment the format of your input string
    const local = moment
        .utc(date, 'MM-DD-YYYY HH:mm', true) // strict parsing
        .local()
        .format(format);

    console.log('utcToLocal local::', local);
    return local;
};

export const localToUTC = (date, format = PAYLOAD_DATE_TIME_FORMAT) => {
    if (!date) return '';
    // if (instanceOf(date, 'Date')) date = date.getTime();
    const local = moment(new Date(date)).utc().format(format);
    return local;
};

export const changeFormat = (date, format) => {
    let ds = '';
    if (!date) return ds;
    if (typeof date === 'string') {
        ds = moment(date).format(format || 'YYYY-MM-DD hh:mm');
    } else {
        ds = moment(new Date(date)).format(format || 'YYYY-MM-DD hh:mm');
    }
    return ds;
};

export const timeTransform = (reciever, donor) => {
    if (!donor || !reciever) return null;

    const recieverDate = new Date(reciever);
    const donorDate = new Date(donor);

    recieverDate.setHours(donorDate.getHours());
    recieverDate.setMinutes(donorDate.getMinutes());
    return recieverDate;
};
